export const Pagination = ({ onUpdate, maxPages, currentPage = 0 }) => {
  return (
    <div className="flex gap-4 justify-center">
      {[...Array(maxPages)].map((_, i) => (
        <div
          key={i}
          className={[
            i === currentPage ? "font-bold bg-black-500 text-white" : "",
            "hover:bg-am-700 hover:text-white px-4 py-2 border rounded-lg cursor-pointer text-md",
          ].join(" ")}
          onClick={() => onUpdate(i)}
        >
          {i + 1}
        </div>
      ))}
    </div>
  );
};
